/** Shared API base URL for all onboarding network requests. */
export const serverURL: string = import.meta.env.VITE_API_URL
